export default __webpack_public_path__ + "static/icon-24-1-0130833448a7fd7f639e0fd57ef583c2.png";